import { useState } from "react";
import { desktopWallpapers, mobileWallpapers } from "@/mocks/gallery";
import Reveal from "@/pages/home/components/Reveal";

export default function WallpaperZone() {
  const [tab, setTab] = useState<"desktop" | "mobile">("desktop");
  const items = tab === "desktop" ? desktopWallpapers : mobileWallpapers;

  return (
    <section id="wallpapers" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-8">
            <div className="max-w-2xl">
              <span className="text-xs font-label tracking-widest text-primary-600 uppercase">Wallpaper Zone</span>
              <h2 className="mt-2 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">壁纸专区</h2>
              <p className="mt-3 text-sm md:text-base text-foreground-700">
                按屏幕类型整理的两组壁纸资源。电脑端使用横版比例并保留侧边留白，手机端使用竖版比例并避开顶部状态栏，选择与设备接近的尺寸即可直接使用。
              </p>
            </div>
            <div className="inline-flex p-1 rounded-full bg-background-100 border border-background-200/80 self-start md:self-auto">
              <button
                type="button"
                onClick={() => setTab("desktop")}
                aria-pressed={tab === "desktop"}
                className={`px-1 py-1 rounded-full text-sm transition-colors cursor-pointer ${
                  tab === "desktop" ? "bg-primary-500 text-background-50" : "text-foreground-600"
                }`}
              >
                <span className="px-4 py-1.5 inline-flex items-center gap-1.5 whitespace-nowrap">
                  <i className="ri-computer-line"></i>桌面壁纸
                </span>
              </button>
              <button
                type="button"
                onClick={() => setTab("mobile")}
                aria-pressed={tab === "mobile"}
                className={`px-1 py-1 rounded-full text-sm transition-colors cursor-pointer ${
                  tab === "mobile" ? "bg-primary-500 text-background-50" : "text-foreground-600"
                }`}
              >
                <span className="px-4 py-1.5 inline-flex items-center gap-1.5 whitespace-nowrap">
                  <i className="ri-smartphone-line"></i>手机壁纸
                </span>
              </button>
            </div>
          </div>
        </Reveal>

        <div className={`grid gap-5 md:gap-6 ${tab === "desktop" ? "grid-cols-1 md:grid-cols-3" : "grid-cols-2 md:grid-cols-3"}`}>
          {items.map((item, index) => (
            <Reveal key={item.id} delay={index * 70}>
              <article className="group h-full rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-accent-300 transition-colors">
                <div className={`relative w-full overflow-hidden ${tab === "desktop" ? "h-44 md:h-52" : "h-72 md:h-96"}`}>
                  <img
                    src={item.image}
                    alt={`${item.title}壁纸预览`}
                    title={`${item.title} · 年轻的岳母壁纸素材`}
                    className="w-full h-full object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-[11px] font-medium text-foreground-950">
                    {item.resolution}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">{item.note}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}